import styles from './AuthContainer.module.scss'
import { PropsWithChildren } from 'react'
import { Card } from '@boltenergy-be/design-system'
import Logo from 'assets/Logo.tsx'

const AuthContainer = ({ children }: PropsWithChildren) => {
  return (
    <main className={styles['auth-container']}>
      <Card as="section" className={styles.card}>
        <Logo className={styles.logo} />

        {children}
      </Card>
    </main>
  )
}

export default AuthContainer
